import { render, staticRenderFns } from "./answerDetail.vue?vue&type=template&id=99b6c9d6&"
import script from "./answerDetail.vue?vue&type=script&lang=js&"
export * from "./answerDetail.vue?vue&type=script&lang=js&"
import style0 from "./answerDetail.vue?vue&type=style&index=0&id=99b6c9d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports